import { useState } from 'react';
import Paper from '@mui/material/Paper';
import InputBase from '@mui/material/InputBase';
// import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
// import MenuIcon from '@mui/icons-material/Menu';
import SearchIcon from '@mui/icons-material/Search';
import { useDispatch, useSelector } from 'react-redux';
import { setSearchString } from '../slices/modeSlice';
import { Divider } from '@mui/material';
// import DirectionsIcon from '@mui/icons-material/Directions';
import CloseIcon from '@mui/icons-material/Close';

export default function SearchInput() {
  const { searchString } = useSelector((state) => state.mode);
  const [value, setValue] = useState(searchString);
  const dispatch = useDispatch();

  const handleSetSearchString = (event, str) => {
    event.preventDefault(0);
    setValue(str);
    dispatch(setSearchString(str));
  };

  return (
    <Paper
      component='form'
      sx={{
        p: '2px 4px',
        display: 'flex',
        alignItems: 'center',
        width: '100%',
        maxWidth: 400,
      }}
      onSubmit={(event) => handleSetSearchString(event, value)}
    >
      {/* <IconButton sx={{ p: '10px' }} aria-label='menu'>
        <MenuIcon />
      </IconButton> */}
      <InputBase
        sx={{ ml: 1, flex: 1 }}
        placeholder='Поиск'
        // inputProps={{ 'aria-label': 'search google maps' }}
        value={value}
        onChange={(e) => setValue(e.target.value)}
      />
      <IconButton
        type='button'
        sx={{ p: '10px' }}
        aria-label='search'
        onClick={(event) => handleSetSearchString(event, value)}
      >
        <SearchIcon />
      </IconButton>
      {searchString && (
        <>
          <Divider sx={{ height: 28, m: 0.5 }} orientation='vertical' />
          <IconButton
            color='primary'
            sx={{ p: '10px' }}
            aria-label='directions'
            onClick={(event) => handleSetSearchString(event, '')}
          >
            <CloseIcon />
          </IconButton>
        </>
      )}
    </Paper>
  );
}
